import React from 'react'
import {
  SiteContainer,
  Wrapper,
  Flex,
  Aside,
  Main
} from 'core/layout'
import tulkojumi from 'utils/tulkojumi'
import { getDataFromACF } from 'utils/deepProps'
import { getPreviousSiblings } from 'utils/siblingNodes'
import { PaginationNav } from 'elements/Pagination'
import KontaktuRezultatsItem from './components/KontaktuRezultatsItem'
import FilterSelect from '../Rezultati/components/FilterSelect'
import { Anchor, BreadcrumbsConnected } from 'elements'

import TextInput from '../Rezultati/components/TextInput'

import {
  FlexGroup,
  StyledHeading,
  StyledList,
  ListHeading,
  StyledFilter,
  FilterLabel,
  StyledH218,
  StyledTermAnchor,
  StyledP,
  SatursLabel,
  HideWhenPrint
} from './styled'

import {
  StyledItem
} from './components/KontaktuRezultatsItem/styled'

import {
  StyledAnchor
} from 'elements/Anchor/styled'

// import every from 'lodash/every'
// import includes from 'lodash/includes'

let jump
if (__isBrowser__) { // eslint-disable-line no-undef
  import('jump.js')
  .then(jumpModule => {
    jump = jumpModule.default
  })
}


const persistPrintStateKey = '_rezultati_printState'
const initialPrintState = {
  id: []
}

const getSearchQuery = location => {
  if (location) {
    const { search } = location
    if (search && 'URLSearchParams' in window) {
      const searchParams = new URLSearchParams(search)
      const searchQuery = searchParams.get('q')
      return searchQuery
    }
    return null
  }
  return null
}


class KontaktiRezultati extends React.PureComponent {
    constructor(props) {
      super(props)
      this.state = this._getInitialPrintState()
    }

    componentDidMount() {
      window.onbeforeprint = this._onBeforePrint
      window.onafterprint = this._onAfterPrint

      const { initialFilterState } = this.props
      const { searchInput } = (initialFilterState && initialFilterState.input) || {}
      const searchQuery = getSearchQuery(window.location) || searchInput
      if (searchQuery) {
        this._searchInResults(searchQuery)
        this._filterInputRef.value = searchQuery
      }
    }

    componentWillUnmount() {
      window.onbeforeprint = null
      window.onafterprint = null
    }

    _getInitialPrintState = () => {
      try {
        let persistPrintState = sessionStorage.getItem(persistPrintStateKey)
        if (persistPrintState) {
          persistPrintState = JSON.parse(persistPrintState)
          return persistPrintState
        }
      } catch (error) { }

      return initialPrintState
    }

    // NOTE: Pieglabājam UI stāvokli, jo print
    // ietekmē notiek pārrenderēšanas process.
    _onBeforePrint = () => {
      try {
        sessionStorage.setItem(persistPrintStateKey, JSON.stringify(this.state))
      } catch (error) { }
    }

    _onAfterPrint = () => {
      sessionStorage.removeItem(persistPrintStateKey)
    }

    // paver vaļā kontaktu lapu
    _toggleRow = (event, id) => {
        event.preventDefault()
        const ID = this.state.id
        const index = this.state.id.indexOf(id)
        if (index === -1) {
            ID.push(id)
            // FIXME: Nepilnīgs risinājums, kas nodrošina atvērtās kontaktu grupas
            // virsraksta iezīmēšanu, lai atšķirtu vai grupa satur pavērtu ierakstu.
            // – šobrīd, gadījumā, ja visi grupas ieraksti tiek aizvērti,
            //   pievienotā klase (iezīme) paliek.
            // - pēc onbeforeprint minētā klase netiek pievienota.
            // this._markGroupTitle(event);
        } else {
            ID.splice(index, 1)
        }
        this.setState(prevState => Object.assign({}, prevState, {
           id: ID
        }))
        this.forceUpdate()
    }

    _markGroupTitle = event => {
      const { target } = event
      let depth = 0
      let li = target
      while (li.nodeName !== 'LI') {
        li = li.parentNode
        if (++depth > 5) {
          li = null
          break
        }
      }
      if (li) {
        const groupTitle = getPreviousSiblings(li).find(li => li.classList.contains('title'))
        if (groupTitle) {
          groupTitle.classList.add('hasOpen')
        }
      }
    }

    _getFilterLabel = (slug, teksti, { allTerms } = {}) => {
      switch (slug) {
        case 'kontakti_iestades':
          return allTerms ?
            tulkojumi(teksti, 'visas_kontaktu_iestades') :
            tulkojumi(teksti, 'kontaktu_iestade')
        default:
          return ''
      }
    }
    _filterTerms = allPosts => {
        let last_term = ''
        this.TERMS = []
        this.TERMS_NAMES = []

        allPosts.map((post, index) => {
                      let new_term = false
                      if (last_term !== post.terms.kontakti_iestades[0].slug) {
                        last_term = post.terms.kontakti_iestades[0].slug
                        new_term = true
                        const index = this.TERMS_NAMES.indexOf(last_term)
                        if (index === -1) {
                            this.TERMS.push(Object.assign({}, post.terms.kontakti_iestades[0], {
                              count: 1
                            }))
                            this.TERMS_NAMES.push(last_term)
                        } else {
                            // this.TERMS.splice(index,1)
                            // this.TERMS_NAMES.splice(index,1)
                        }
                      }
        })
         return {
            terms_names: this.TERMS_NAMES,
            terms: this.TERMS
         }
    }

  _searchInResults = searchstring => {
    if (searchstring !== '') {
      window.gtag && gtag('event', 'search', {
        event_label: 'pasvaldibas_kontakti',
        search_term: searchstring
      })

      const postClone = Object.assign([], this.props.postsData.posts)
      const filtered = this.props.postsData.posts.map((post, index) => {
        let amats_result = false
        let vards_uzvards_result = false
        let amats_mach = false
        let vards_mach = false
        let acfData
        try {
            acfData = post.acf && JSON.parse(post.acf)
        } catch (error) { }

        let clean_post = {}
        const title_result = post.title.match(new RegExp(searchstring, 'i'))

        if (!title_result && acfData.nodala && acfData.nodala[0] && acfData.nodala[0].kontakts) {
          for (let i = 0; i < acfData.nodala.length; i++) {
            const filtred_contacts = []
            for (let i2 = 0; i2 < acfData.nodala[i].kontakts.length; i2++) {
              amats_result = acfData.nodala[i].kontakts[i2].amats.match(new RegExp(searchstring, 'i'))
              vards_uzvards_result = acfData.nodala[i].kontakts[i2].vards_uzvards.match(new RegExp(searchstring, 'i'))

              if (amats_result) {
                amats_mach = true
              }
              if (vards_uzvards_result) {
                vards_mach = true
              }

              if (vards_uzvards_result || amats_result) {
                filtred_contacts.push(acfData.nodala[i].kontakts[i2])
              }
            }
            acfData.nodala[i].kontakts = filtred_contacts
            if (filtred_contacts.length === 0) {
              acfData.nodala[i] = false
            }
          }
        }

        clean_post = Object.assign({}, post, {
          acf: JSON.stringify(acfData)
        })

        return (title_result || vards_mach || amats_mach) ? clean_post : false
      })

      this.allPosts = filtered.filter(post => post)
      this.setState(prevState => Object.assign({}, prevState, {
        id: this.allPosts.map(post => post._id)
      }))
    } else {
      this.allPosts = this.props.postsData.posts
      this.setState(prevState => Object.assign({}, prevState, {
        id: []
      }))
    }

    this.setState(prevState => Object.assign({}, prevState, {
      searchstring
    }))
  }


  render() {
      const {
        postType,
        postsData,
        termsArray,
        page,
        teksti,
        lang,
        init_page,
        loadMoreEntries,
        filterKeywords,
        filterState,
        filter,
        perpage,
        paginate,
        ...rest
      } = this.props

      const pagesTotal = Math.ceil(postsData.total / perpage)

      if (!this.allPosts) {
        this.allPosts = postsData.posts
      }



      const renderSearcher = () => {
        return (
          <StyledFilter>
              <TextInput
                innerRef={c => this._filterInputRef = c}
                placeholder={tulkojumi(teksti, 'satur_vardus')}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault()
                    this._searchInResults && this._searchInResults(event.target.value)
                  }
                }}
              />
          </StyledFilter>
        )
      }


      const renderTermsAnchors = slug => {
        const filtered_terms = this._filterTerms(this.allPosts)

        const terms = filtered_terms.terms && filtered_terms.terms.map((term, index) => term.count > 0 ? (
          <StyledTermAnchor key={index}>
            <li>
              <StyledAnchor
                href={`#${term.slug}`}
                onClick={event => {
                  event.preventDefault()
                  jump && jump(`#${term.slug}`, {
                    duration: 250,
                    offset: -85,
                    a11y: true
                  })
                }}
              > {term.name}</StyledAnchor>
            </li>
          </StyledTermAnchor>
        ) : null
        )

        return terms.length > 0 ? <div><SatursLabel>{tulkojumi(teksti, 'saturs')}</SatursLabel>{terms}</div> : null
      }


      const renderFilter = slug => {
        if (slug === 'search') {
          return (
            <StyledFilter key={slug}>
              <FilterLabel>
                {tulkojumi(teksti, 'satur_vardus')}
              </FilterLabel>
                <TextInput
                  defaultValue={filterState[slug]}
                  placeholder={tulkojumi(teksti, 'satur_vardus')}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      event.preventDefault()
                      filterKeywords && filterKeywords(event.target.value)
                    }
                  }}
                />
            </StyledFilter>
          )
        }

        const terms = postsData.terms[slug]
        const filteredData = filterState[slug]

        return terms && (
          <StyledFilter key={slug}>
            <FilterLabel>
              {this._getFilterLabel(slug, teksti)}
            </FilterLabel>
            <FilterSelect
              defaultOption={{
                id: slug,
                label: this._getFilterLabel(slug, teksti, { allTerms: true }),
                selected: !filteredData
              }}
              options={terms && terms.map(term => ({
                id: term.slug,
                label: term.name,
                count: term.count,
                selected: filteredData && filteredData.indexOf(term.slug) > -1
              }))}
              onChange={(id, selected) => {
                if (id === slug) {
                  filter(event, slug, null)
                } else {
                  filter(event, slug, id)
                }
              }} />
          </StyledFilter>
        )
      }


      const renderPagination = (rel, currentPage) => (
          <PaginationButton
              rel={rel}
              path='#'
              label={`${currentPage} ${tulkojumi(teksti, 'no')} ${pagesTotal}`}
              teksti={teksti} />
        )

      const getPageButtonLabel = currentPage => (
        `${currentPage} ${tulkojumi(teksti, 'no')} ${pagesTotal}`
      )

      const prevPage = (filterState.page > 0) && {
        label: getPageButtonLabel(filterState.page),
        onClick: () => paginate(filterState.page - 1)
      }

      const nextPage = (filterState.page < pagesTotal - 1) && {
        label: getPageButtonLabel(filterState.page + 2),
        onClick: () => paginate(filterState.page + 1)
      }


      let filters
      if (postType === 'pasvaldibas_kontakti') {
        filters = [
          'search'
          // 'kontakti_iestades'
        ]
      }


      let last_term = ''

      return (
        <SiteContainer>

          <BreadcrumbsConnected
            lang={lang}
            path={init_page.path} />

          <Wrapper>
            <StyledHeading>
                {init_page.title}
            </StyledHeading>

            <FlexGroup>
              <Aside style={{ width: '100%' }}>
                <StyledP>{tulkojumi(teksti, 'izmantojot_mekletaju')}</StyledP>
                {renderSearcher()}
                {renderTermsAnchors('kontakti_iestades')}
              </Aside>

              <Main>

                <StyledList>

                  {
                    this.allPosts && this.allPosts.length > 0 ? this.allPosts.map((post, index) => {
                      let new_term = false
                      if (last_term !== post.terms.kontakti_iestades[0].name) {
                        last_term = post.terms.kontakti_iestades[0].name
                        new_term = true
                      }

                      let acfData
                      try {
                        acfData = post.acf && JSON.parse(post.acf)
                      } catch (error) { }

                      if (post.title === '') {
                        return null
                      }

                      return (
                        <KontaktuRezultatsItem
                          key={index}
                          lang={lang}
                          teksti={teksti}
                          postType={postType}
                          new_term={new_term}
                          opened={this.state.id.indexOf(post._id) !== -1}
                          _toggleRow={this._toggleRow}
                          {...post} />
                      )
                    }) : <li><StyledH218>{tulkojumi(teksti, 'neviens_kontakts_neatbilst_filtram')}</StyledH218></li>
                  }
                </StyledList>

                <PaginationNav
                  prev={prevPage}
                  next={nextPage}
                  teksti={teksti} />

              </Main>
            </FlexGroup>
          </Wrapper>
        </SiteContainer>
    )
  }
}

export default KontaktiRezultati



// WEBPACK FOOTER //
// ./src/pages/KontaktiRezultati/KontaktiRezultati.jsx